import { Box, Flex, Text, useDisclosure } from "@chakra-ui/react";
import { FaPlus } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect, useRef } from "react";

const MotionBox = motion(Box);
const MotionIcon = motion(FaPlus);

const Question = ({ title, description, rotation, direction }) => {
  const { isOpen, onToggle } = useDisclosure();
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (isOpen && contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [isOpen]);

  return (
    <MotionBox
      position="relative"
      display="inline-flex"
      alignItems="center"
      padding="16px"
      fontSize="16px"
      color="white"
      borderRadius="12px"
      initial={{
        background: `linear-gradient(${rotation}, rgba(255, 255, 255, 0.0) 0%, rgba(255, 255, 255, 0.05) 100%)`,
      }}
      animate={{
        background: `linear-gradient(${rotation}, rgba(255, 255, 255, 0.0) 0%, rgba(255, 255, 255, 0.05) 100%)`,
      }}
      transition={{ duration: 0.4, ease: "easeInOut" }} 
      _before={{
        content: '""',
        position: "absolute",
        inset: "0",
        borderRadius: "12px",
        padding: "1px",
        background: `linear-gradient(to ${direction}, rgba(255, 255, 255, 0.25) 25%, rgba(255, 255, 255, 0.00) 100%)`,
        WebkitMask:
          "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
        WebkitMaskComposite: "xor",
        maskComposite: "exclude",
        pointerEvents: "none",
        transition: "background 0.4s ease-in-out", 
      }}
      width={{ base: "100%", lg: "70%", xl: "550px" }}
      height={"auto"}
    >
      <Flex direction="column" width="100%">
        <Flex
          direction="row"
          gap="19px"
          width="100%"
          alignItems="center"
          justifyContent="space-between"
          onClick={onToggle}
          userSelect="none"
          cursor="pointer"
        >
          <Text fontSize="16px" color="#BEBEBE">
            {title}
          </Text>
          <MotionIcon
            size={10}
            color="#BEBEBE"
            animate={{ rotate: isOpen ? -45 : 0 }}
            transition={{ duration: 0.3 }}
          />
        </Flex>

        <AnimatePresence initial={false}>
            <MotionBox
              ref={contentRef}
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: height, opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              overflow="hidden"
            >
              <Text fontSize="16px" color="#BEBEBE" mt="10px">
                {description}
              </Text>
            </MotionBox>
        </AnimatePresence>
      </Flex>
    </MotionBox>
  );
};

export default Question;
